export const sqlToHtml = (sql) => {
    const normalized = sql.replace(/\\n/g, '\n');
    return `<pre><code>${normalized}</code></pre>`;
};
